import { ColorPicker } from '@src/ui/elements/color/ColorPicker';
import { pickFontColor } from '@src/utils/colorPickerUtil';
import type { Editor } from '@tiptap/react';
import React, { useEffect, useRef, useState } from 'react';
import { FaPaintBrush } from 'react-icons/fa';

interface FontColorButtonProps {
  editor: Editor;
}

export const FontColorButton: React.FC<FontColorButtonProps> = ({ editor }) => {
  const [showFontColors, setShowFontColors] = useState(false);
  const [recentFontColor, setRecentFontColor] = useState('#000000');
  const fontColorsRef = useRef<HTMLDivElement | null>(null);

  function handlePickFontColor(color: string) {
    pickFontColor(editor, color, setRecentFontColor);
  }

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (fontColorsRef.current && !fontColorsRef.current.contains(event.target as Node)) {
        setTimeout(() => setShowFontColors(false), 10);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={fontColorsRef}
      className='dropdownWrapper'
      title='テキストの色'
    >
      <button
        onClick={() => setShowFontColors(!showFontColors)}
        className='toolbar-button'
        type='button'
      >
        <FaPaintBrush />
      </button>
      {showFontColors && (
        <ColorPicker
          recentColor={recentFontColor}
          onColorSelect={handlePickFontColor}
          onClose={() => setShowFontColors(false)}
        />
      )}
    </div>
  );
};
